import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sale from "./Sales/Sales";
import RoleManagement from "./RoleBased/RoleManagement";
import AccessManagement from "./RoleBased/AccessManagement";
import StateCityPage from "./RoleBased/StateCityPage";
import TaskManagement from "./TaskManagement/TaskManagement";
import DailyWorksheet from "./TaskManagement/DailyWorksheet";
import EmployeeDetails from "./EmployeeManagement/EmployeeDetails";
import RawMaterialCategories from "./Inventory/RawMaterialCategory";
import Shop from "./pages/Shop/Shop";
import Main from "./pages/Main";
import Login from "./pages/Login/Login";
import VerifyOtp from "./pages/Login/VerifyOtp";
import Signuprequest from "./pages/SignUp/Signuprequest";
import Register from "./pages/Register/Register";
import Dashboard from "./pages/Home/Dashboard";
import ProtectedRoute from "./Navigation/ProtectedRoute";
import ProtectedAccessRoute from "./Navigation/ProtectedAccessRoute";
import RawMaterial from "./Inventory/RawMaterial"
import RawMaterialDetailPage from "./Inventory/RawMaterialDetailPage";
import DoorDetailPage from "./pages/Watchlist/DoorDetailPage";
import Watchlist from "./pages/Watchlist/Watchlist";
 import CartCheckoutPage from "./pages/Cart/CartCheckoutPage";
import SaleOrderDetail from "./Sales/SaleOrderDetail";
import AdminAttendancePanel from "./Attendence/AdminAttendancePanel";
import EmployeeAttendance from "./Attendence/EmployeeAttendance";
import AddProduct from "./Inventory/ProductDesign/AddProduct";
import ProductCategories from "./Inventory/ProductDesign/ProductCategories";
import WoodQualities from "./Inventory/ProductDesign/WoodQualities";
import StockStatement from "./Inventory/StockStatement";
import OrderDetails from "./Sales/OrderDetails";
import VendorManagement from "./VendorManagement/VendorManagement";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/ForgotPassword/ResetPassword";
import VendorDetailPage from "./VendorManagement/VendorDetailPage";
import AccountManagement from "./Accounts/AccountManagement";
import CustomerAccountDetailPage from "./Accounts/CustomerAccountDetailPage";
import PurchaseOrder from "./PurchaseOrder/PurchaseOrder";
import PurchaseOrderDetail from "./PurchaseOrder/PurchaseOrderDetail";
import Expenses from "./Expenses/Expenses";
import ExpenseDetail from "./Expenses/ExpenseDetail";
import CustomerOrders from "./Sales/CustomerOrders";
import ProductDetailPage from "./Inventory/ProductDesign/ProductDetailPage";
import FullWidthBlade, {
  ProtectedListLayout,
  RedirectToNestedBlade,
} from "./Customs/FullWidthBlade/FullWidthBlade";
import { useSelector } from "react-redux";
import { RootState } from "./Services/Store";
import TrackPayment from "./Sales/TrackPayment";
import TrackOrder from "./Sales/TrackOrder";
import DeleteDataPage from "./pages/Whatsaaphtml/DeleteDataPage";
import PrivacyPolicy from "./pages/Whatsaaphtml/PrivacyPolicy"
import TermsOfService from "./pages/Whatsaaphtml/Terms-Services"


const App = () => {
  const userRole = useSelector((state: RootState) => state.auth.user?.user_type); 

  return (

    
    <Routes>
      {/* ───────────── Public routes ───────────── */}
      <Route path="/login" element={<Login />} />
      <Route path="/verifyOtp" element={<VerifyOtp />} />
      <Route path="/signuprequest" element={<Signuprequest />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/resetPassword" element={<ResetPassword />} />
       <Route path="/delete-data" element={<DeleteDataPage />} />
       <Route path="/privacy-policy" element={<PrivacyPolicy />} />
       <Route path="/terms-service" element={<TermsOfService />} />

      {/* ───────────── Main entry point for authenticated users ───────────── */}
      <Route
        path="/"
        element={
          <ProtectedRoute
            authenticationPath="/login"
            outlet={<Main />} 
          />
        }
      >
        {/* Dynamic redirection for the root authenticated path based on role */}
        <Route
          index
          element={
            userRole === "CUSTOMER" ? (
              <Navigate to="/shop" replace /> 
            ) : (userRole === "ADMIN" || userRole === "EMPLOYEE") ? (
              <Dashboard /> 
            ) : (
              <Navigate to="/shop" replace /> 
            )
          }
        />

        {/* ───────────── Routes visible to ALL authenticated users (e.g., Shop, Cart) ───────────── */}
        <Route path="/shop" element={<Shop />} />
        <Route path="/watchlist/:type/:id" element={<Watchlist />} />
        <Route path="/watchlist/:type/:id/:itemId" element={<DoorDetailPage />} />
        <Route path="/cart" element={<CartCheckoutPage />} />
        
         <Route path="/accounts/customer/:userId" element={<CustomerAccountDetailPage />} />

        {/* ───────────── Admin/Employee Specific Routes ───────────── */}
        <Route
          path="sales"
          element={
            <ProtectedAccessRoute
              authenticationPath="/login"
              accessCode="saleorder_management"
              requiredPermission="read"
              outlet={<Sale />}
            />
          }
        />
<Route
  path="/saleorder/:orderId"
  element={
    <ProtectedAccessRoute
      authenticationPath="/login"
      accessCode="saleorder_management"
      requiredPermission="read"
      outlet={<SaleOrderDetail />}
    />
  }
/>

        {/* <Route
          path="saleorder/:orderId/order-details"
          element={
            <ProtectedAccessRoute
              authenticationPath="/login"
              accessCode="saleorder_management"
              requiredPermission="read"
              outlet={<OrderDetails />}
            />
          }
        /> */}
        <Route
  path="saleorder/:orderId/track-payment"
  element={
    <ProtectedAccessRoute
      authenticationPath="/login"
      accessCode="saleorder_management"
      requiredPermission="read"
      outlet={<TrackPayment />}
    />
  }
/>
    <Route
  path="saleorder/:orderId/track-orders"
  element={
    <ProtectedAccessRoute
      authenticationPath="/login"
      accessCode="saleorder_management"
      requiredPermission="read"
      outlet={<TrackOrder />}
    />
  }
/>


        {/* ───────────── Customer Specific Routes (Matching Backend Module) ───────────── */}
        <Route
          path="/mysaleorder-management" 
          element={
            <ProtectedAccessRoute 
              authenticationPath="/login"
              accessCode="mysaleorder_management" 
              requiredPermission="read"
              outlet={<CustomerOrders />}
            />
          }
        />
<Route
  path="/mysaleorder-management/:orderId"
  element={
    <ProtectedAccessRoute
      authenticationPath="/login"
      accessCode="mysaleorder_management"
      requiredPermission="read"
      outlet={<SaleOrderDetail />}
    />
  }
/>
<Route
  path="/mysaleorder-management/:orderId/order-details"
  element={
    <ProtectedAccessRoute
      authenticationPath="/login"
      accessCode="mysaleorder_management"
      requiredPermission="read"
      outlet={<OrderDetails />}
    />
  }
/>
<Route
  path="/mysaleorder-management/:orderId/track-payment"
  element={
    <ProtectedAccessRoute
      authenticationPath="/login"
      accessCode="mysaleorder_management"
      requiredPermission="read"
      outlet={<TrackPayment />}
    />
  }
/>
<Route
  path="/mysaleorder-management/:orderId/track-orders"
  element={
    <ProtectedAccessRoute
      authenticationPath="/login"
      accessCode="mysaleorder_management"
      requiredPermission="read"
      outlet={<TrackOrder />}
    />
  }
/>




        {/* ───────────── Other Existing Protected Routes ───────────── */}

        {/* Accounts Management */}
        <Route
          path="/accounts-management"
          element={<ProtectedListLayout accessCode="accounts_management" list={<AccountManagement />} />}
        >
          <Route
            path="customer/:userId"
            element={
              <FullWidthBlade listPath="/accounts-management">
                <CustomerAccountDetailPage />
              </FullWidthBlade>
            }
          />
        </Route>
        <Route path="/accounts/:userId" element={<CustomerAccountDetailPage />} />

        {/* Inventory Management */}
        <Route path="/raw-material" element={<RawMaterial />}>
          <Route
            path=":id"
            element={
              <FullWidthBlade listPath="/raw-material">
                <RawMaterialDetailPage />
              </FullWidthBlade>
            }
          />
        </Route>
        <Route
          path="/inventory/raw-material/:id"
          element={<RedirectToNestedBlade toPrefix="/raw-material" />}
        />
        <Route path="/inventory/raw-material-categories" element={<RawMaterialCategories />} />
       <Route
          path="/inventory/product-design"
          element={<ProtectedListLayout accessCode="inventory_management" list={<AddProduct />} />}
        >
          <Route
            path=":id"
            element={
              <FullWidthBlade listPath="/inventory/product-design">
                <ProductDetailPage />
              </FullWidthBlade>
            }
          />
        </Route>

        <Route path="/inventory/product-categories" element={<ProductCategories />} />
        <Route
          path="/inventory/wood-qualities"
          element={
            <ProtectedAccessRoute
              authenticationPath="/login"
              accessCode="inventory_management"
              requiredPermission="read"
              outlet={<WoodQualities />}
            />
          }
        />
        <Route
          path="/inventory/stock-statement"
          element={
            <ProtectedAccessRoute
              authenticationPath="/login"
              accessCode="inventory_management"
              requiredPermission="read"
              outlet={<StockStatement />}
            />
          }
        />
        <Route path="/inventory/product/:id" element={<ProductDetailPage />} />

        {/* Attendance Role-Based Protection */}
<Route
  path="/attendance"
  element={
    <ProtectedRoute
      authenticationPath="/login"
      allowedUserTypes={["EMPLOYEE"]}
      outlet={<EmployeeAttendance />}
      redirectPath="/attendance-admin"
    />
  }
/>
<Route
  path="/attendance-admin"
  element={
    <ProtectedRoute
      authenticationPath="/login"
      allowedUserTypes={["ADMIN"]}
      outlet={<AdminAttendancePanel />}
      redirectPath="/attendance"
    />
  }
/>


        {/* Employee Management */}
        <Route
          path="employee-management"
          element={
            <ProtectedAccessRoute
              authenticationPath="/login"
              accessCode="employee_management"
              requiredPermission="read"
              outlet={<EmployeeDetails />}
            />
          }
        />

        {/* Task Management */}
        <Route
          path="task-management/:user_id"
          element={
            <ProtectedAccessRoute
              authenticationPath="/login"
              accessCode="task_management"
              requiredPermission="read"
              outlet={<TaskManagement />}
            />
          }
        />
        <Route
          path="task-management"
          element={
            <ProtectedAccessRoute
              authenticationPath="/login"
              accessCode="task_management"
              requiredPermission="read"
              outlet={<TaskManagement />}
            />
          }
        />
        <Route
          path="daily-worksheet"
          element={
            <ProtectedRoute
              authenticationPath="/login"
              allowedUserTypes={["ADMIN"]}
              outlet={
                <ProtectedAccessRoute
                  authenticationPath="/login"
                  accessCode="task_management"
                  requiredPermission="read"
                  outlet={<DailyWorksheet />}
                />
              }
            />
          }
        />

        {/* Role/Access Control */}
        <Route
          path="role-management"
          element={
            <ProtectedAccessRoute
              authenticationPath="/login"
              accessCode="rba_control"
              requiredPermission="read"
              outlet={<RoleManagement />}
            />
          }
        />
        <Route
          path="access-management"
          element={
            <ProtectedAccessRoute
              authenticationPath="/login"
              accessCode="rba_control"
              requiredPermission="read"
              outlet={<AccessManagement />}
            />
          }
        />
        <Route
          path="state-city"
          element={
            <ProtectedRoute
              authenticationPath="/login"
              allowedUserTypes={["ADMIN", "EMPLOYEE"]}
              outlet={<StateCityPage />}
            />
          }
        />

        {/* Vendor Management */}
        <Route
          path="vendor-management"
          element={
            <ProtectedAccessRoute
              authenticationPath="/login"
              accessCode="vendor_management"
              requiredPermission="read"
              outlet={<VendorManagement />}
            />
          }
        />
        <Route path="/vendor-management/:vendorId" element={<VendorDetailPage />} />

        {/* Purchase Order Management */}
        <Route
  path="/purchase-management"
  element={
    <ProtectedAccessRoute
      authenticationPath="/login"
      accessCode="purchase_management"
      requiredPermission="read"
      outlet={<PurchaseOrder />}
    />
  }
/>

     <Route
  path="/purchase-order/:purchase_order_id"
  element={
    <ProtectedAccessRoute
      authenticationPath="/login"
      accessCode="purchase_management"
      requiredPermission="read"
      outlet={<PurchaseOrderDetail />}
    />
  }
/>

        <Route
          path="/expenses"
          element={
            <ProtectedAccessRoute
              authenticationPath="/login"
              accessCode="expense_management"
              requiredPermission="read"
              outlet={<Expenses />}
            />
          }
        />
        <Route
          path="/expenses/:expenseId"
          element={
            <ProtectedAccessRoute
              authenticationPath="/login"
              accessCode="expense_management"
              requiredPermission="read"
              outlet={<ExpenseDetail />}
            />
          }
        />

      </Route> {/* End of <ProtectedRoute outlet={<Main />} /> */}
      
      {/* Fallback for unmatched routes */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;